import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["signup.exchangePlaidLoading"],
  loading => loading
);
